import { HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IPluginStoreValue } from "@gtmhub/plugins";
import { RequestConfig } from "@webapp/core/abstracts/models/request-config.model";
import { BaseFacade } from "@webapp/core/abstracts/services/base-facade.service";
import { Plugin, PluginDTO } from "@webapp/plugins/plugins.models";
import { PluginsApiService } from "@webapp/plugins/services/plugins-api.service";
import { PluginsState } from "@webapp/plugins/services/plugins-state.service";

interface PluginErrorInterface<T> {
  statusCode: number;
  error: T;
  url: string;
}

@Injectable({
  providedIn: "any",
})
export class PluginsFacade extends BaseFacade<Plugin, PluginDTO, PluginsState, PluginsApiService> {
  public constructor(state: PluginsState, api: PluginsApiService) {
    super(state, api);
  }

  public getPluginStore$(params: { pluginId: string; key: string }): Observable<IPluginStoreValue> {
    return this.apiService.get$<IPluginStoreValue>(null, {
      ...new RequestConfig(),
      ...params,
      url: this.apiService.getPluginStoreEndpoint(params.pluginId, params.key),
    });
  }

  public transformHttpError<T>(error: HttpErrorResponse): PluginErrorInterface<T> {
    return {
      statusCode: error.status,
      error: error.error,
      url: error.url,
    };
  }
}
